import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "Config/Api";
import { API_ENDPOINTS } from "Config/apiConfig";
import { AppType } from "types/appType";
import { ErrorType } from "types/errorType";
import { IncidentNoteType } from "types/incidentNoteType";

export interface AppTypeWithIncidentCreateType extends AppType {
  loading: boolean;
  error: ErrorType | null;
  incidentNote: IncidentNoteType;
}

const initialState: AppTypeWithIncidentCreateType = {
  error: null,
  loading: false,
  incidentNote: {
    note: "",
  },
};

export const createNote = createAsyncThunk<void, { incidentId: string; note: IncidentNoteType }>(
  "incidentNote/createNote",
  async ({ incidentId, note }, { rejectWithValue }) => {
    try {
      await api.post<IncidentNoteType>(API_ENDPOINTS.incidentNotes(incidentId), note);
    } catch (err: any) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const incidentNoteSlice = createSlice({
  name: "incidentNote",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createNote.fulfilled, (state, action) => {
      return {
        ...state,
        error: null,
        loading: false,
      };
    });
    builder.addCase(createNote.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createNote.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as ErrorType;
    });
  },
});

export const { clearError } = incidentNoteSlice.actions;
export default incidentNoteSlice.reducer;
